export default __webpack_public_path__ + "static/media/MasterControl.1e44f530.png";